import { useEffect, useState } from "react";
import axios from "axios";
import Loader from "./Loader";

const API_BASE_URL = process.env.REACT_APP_TRANSLATION_API_BASE_URL;


export default function PromptViewer({selectedProduct}) {
  const [prompt, setPrompt] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE_URL}core-prompt/${selectedProduct}`)
      .then(res => setPrompt(res.data.core_prompt))
      .catch(() => setPrompt("Error loading prompt."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="border p-4 rounded shadow bg-gray-50">
      <h2 className="text-xl font-semibold mb-2">📜 Core Prompt</h2>
      {loading ? <Loader message="Loading prompt..." /> : (
        <pre className="bg-gray-100 p-4 rounded overflow-auto whitespace-pre-wrap">
          {prompt}
        </pre>
      )}
    </div>
  );
}
